import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import './index.css';

import img1 from '../../../src/images/left-white.svg'
import img2 from '../../../src/images/7-days-icon.svg'
import img3 from '../../../src/images/arr-down2.svg'
import img4 from '../../../src/images/time-in-range-chart.svg'
import img5 from '../../../src/images/key-insights-icon.svg'
import img6 from '../../../src/images/recommendation-icon.svg'

import img8 from '../../../src/images/home2.svg';
import img9 from '../../../src/images/Icon (5).svg';
import img10 from '../../../src/images/notification.svg';
import img11 from '../../../src/images/Calendar3.svg';
import img12 from '../../../src/images/Icon (6).svg';
import config from '../../config/config';


function TimeInRange() {
    const navigate = useNavigate();
    const location = useLocation();
    const { patientName, patientAge, patientCondition, patientId } = location.state || {};
    const [patients, setPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const backendURL = `${config.backendServerHost}`;


// Place console.log statements to debug received state
console.log('Received data in GlucoseLevel:', {
    patientName,
    patientAge,
    patientCondition,
    patientId,
  });

useEffect(() => {
    fetch(`${backendURL}/patients/api/patients`)
        .then((res) => res.json())
        .then((data) => {
            setPatients(data); // Store all patients
            const foundPatient = data.find(patient => patient.name === patientName); // Find patient by name
            if (foundPatient) {
                setSelectedPatient(foundPatient); // Set the selected patient
            } else {
                console.error(`Patient with name "${patientName}" not found.`);
            }
        })
        .catch((error) => console.error('Error fetching patients:', error));
}, [backendURL, patientName]);

    const navigateTo = (path, state = {}) => {
    navigate(path, { state });
    };

    return (
        <div className="glucose-main-cantainer">
            <div className='glucose_container'>
                <div className='glucose-navbar'>
                <div onClick={() => 
                    navigateTo('/patientinfo', {
                        state: { 
                            patientName, 
                            patientAge, 
                            patientCondition, 
                            patientId 
                        },
                    })
            }>



                    <img src={img1} alt="Back to Patient Info" />
                    </div>
                    <div><h4>Glucose Trend</h4></div>
                    <div></div>
                </div>
                <div className='days-button'><span><img src={img2} alt="" /></span><h6>7 Days</h6><span><img src={img3} alt="" /></span></div>
                <div className='date-heading'><h5>Nov 7 - Nov 13, 2024</h5></div>
                <div className='glucose_trend_cnt'>
                    <div className='average_glucose time-in-range-cnt'>
                        <h3>10%</h3>
                    </div>
                    <div className='average_glucose time-in-range-cnt'>
                        <h3>65%</h3>
                    </div>
                    <div className='average_glucose time-in-range-cnt'>
                        <h3>25%</h3>
                    </div>
                </div>
                {/* <div className='glucose_trend_text'>
                    <div><h3>Avg Glucose</h3></div>
                    <div><h3>Time in Range</h3></div>
                    <div><h3>7 Days</h3></div>
                </div> */}
                <div className='charts-image'>
                    <img src={img4} alt="" />
                </div>
            </div>
            <div className='glucose-wrapper'>
                <div className='key-insights-heading'>
                    <h2>Key Insights</h2>
                </div>
                <div className='key_insights_cnt'>
                    <div>
                        <img src={img5} alt="" />
                    </div>
                    <div>
                        <h4>Key Insights</h4>
                        <p>Victor Borg, spent 62% of the week in the target glucose range (70-180 mg/dL)</p>
                    </div>
                </div>
                <div className='key_insights_cnt'>
                    <div>
                        <img src={img6} alt="" />
                    </div>
                    <div>
                        <h4>Recommendations </h4>
                        <p>Adjust evening insulin dose.</p>
                    </div>
                </div>
                <div className='key-insights-heading'>
                    <h2>Event Log</h2>
                </div>
                <div className='event_container1'>
                    <div>
                        <h2>Hypo Event</h2>
                        <h3>Nov 10 15:30</h3>
                        <h4>Blood glucose: 52 mg/dL</h4>
                    </div>
                    <div>
                        <h5>High</h5>
                    </div>
                </div>
                <div className='event_container1 event_container2'>
                    <div>
                        <h2>Hypo Event</h2>
                        <h3>Nov 10 15:30</h3>
                        <h4>Blood glucose: 52 mg/dL</h4>
                    </div>
                    <div>
                        <h5>Moderate</h5>
                    </div>
                </div>
                <div className='event_container1'>
                    <div>
                        <h2>Hypo Event</h2>
                        <h3>Nov 10 15:30</h3>
                        <h4>Blood glucose: 52 mg/dL</h4>
                    </div>
                    <div>
                        <h5>High</h5>
                    </div>
                </div>
                <div className='event_container1 event_container2'>
                    <div>
                        <h2>Hypo Event</h2>
                        <h3>Nov 10 15:30</h3>
                        <h4>Blood glucose: 52 mg/dL</h4>
                    </div>
                    <div>
                        <h5>Moderate</h5>
                    </div>
                </div>
            </div>

            <div className="footer_container_wrapper">
                <div className="footer_container">
                    <div className="footer_icon" onClick={() => navigate('/')}>
                        <img src={img8} alt="Home Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/analysis')}>
                        <img src={img9} alt="Analytics Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/alerts')}>
                        <img src={img10} alt="Notification Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/appointments')}>
                        <img src={img11} alt="Calendar Icon" />
                    </div>
                    <div style={{ cursor: "pointer" }}>
                        <img src={img12} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TimeInRange;
